var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{ref:"inputEl",staticClass:"input-container",attrs:{"id":_vm.data.id,"type":_vm.data.type,"required":_vm.data.required,"readonly":_vm.data.readonly},domProps:{"value":_setup.resolvedValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }